module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf.7d3e5982.svg";